'use strict';

var Chart = require('chart.js');

Chart = typeof Chart === 'function' ? Chart : window.Chart;

var drawLabelForAnnotations = function drawLabelForAnnotations(_ref) {
  var chart = _ref.chart,
      annotations = _ref.annotations,
      unitLabel = _ref.unitLabel;
  var canvas = chart.canvas;
  var context = canvas.getContext('2d');
  annotations.map(function (annotation) {
    var value = annotation.value;
    context.font = '12px Nunito';
    context.fillStyle = annotation.borderColor;
    context.fillText(value + ' ' + unitLabel, chart.chartArea.right + 10, chart.scales['y-axis-0'].getPixelForValue(value));
  });
};

var AnnotationLabelsPlugin = function AnnotationLabelsPlugin(callback) {
  return {
    x: null,
    y: null,
    callback: callback,
    afterDraw: function afterDraw(targetChart) {
      var unitLabel = targetChart.options.annotation.unitLabel;
      var annotations = targetChart.options.annotation.annotations;
      drawLabelForAnnotations({
        chart: targetChart,
        annotations: annotations,
        unitLabel: unitLabel
      });
    }
  };
};

module.exports = AnnotationLabelsPlugin;
Chart.pluginService.register(AnnotationLabelsPlugin());